if (!customElements.get('invisidoor-selector')) {
  customElements.define(
    'invisidoor-selector',
    class InvisidorSelector extends HTMLElement {
      constructor() {
        super();

        this.currentValue = this.querySelector('[data-current]');
        this.variants = this.querySelectorAll('[data-variant]');
        this.changeVariant();
      }

      changeVariant() {
        if (this.variants.length === 0) return;
        this.variants.forEach((variant) => variant.addEventListener('click', () => this.handleVariantClick(variant)));
      }

      handleVariantClick(variant) {
        this.variants.forEach(variant => variant.classList.remove('active'));
        this.currentValue.innerHTML = variant.dataset.variant;
        variant.classList.add('active');
      }
    }
  );
}
